import ActivitiesContainer from './ActivitiesContainer';
export default ActivitiesContainer;
